export const GetCurrByCode = (code: string) => {
  return CURRENCIES.find((c) => c.code === code);
};

export const GetCurrSymbol = (symbol: string) => {
  return CURRENCIES.find((c) => c.symbol === symbol);

};

export const CURRENCIES = [
  {
    code: "AMD",
    name: "Armenian Dram",
    symbol: "֏",
  },
  {
    code: "USD",
    name: "United States Dollar",
    symbol: "$",
  },
  {
    code: "EUR",
    name: "Euro",
    symbol: "€",
  },
  {
    code: "RUB",
    name: "Russian Ruble",
    symbol: "₽",
  },
  {
    code: "GBP",
    name: "Pound Sterling",
    symbol: "£",
  },
  {
    code: "AED",
    name: "United Arab Emirates Dirham",
    symbol: "د.إ.",
  },
  {
    code: "CHF",
    name: "Swiss Franc",
    symbol: "₣",
  },
  {
    code: "CNY",
    name: "Chinese Yuan",
    symbol: "CN¥",
  },
  {
    code: "HKD",
    name: "Hong Kong Dollar",
    symbol: "HK$",
  },
  {
    code: "ARS",
    name: "Argentine Peso",
    symbol: "AR$",
  },
  {
    code: "AUD",
    name: "Australian Dollar",
    symbol: "AU$",
  },
  {
    code: "BHD",
    name: "Bahraini Dinar",
    symbol: "د.ب.",
  },
  {
    code: "BRL",
    name: "Brazilian Real",
    symbol: "R$",
  },
  {
    code: "BYN",
    name: "Belarusian Ruble",
    symbol: "Br",
  },
  {
    code: "CAD",
    name: "Canadian Dollar",
    symbol: "CA$",
  },
  {
    code: "CUP",
    name: "Cuban Peso",
    symbol: "₱",
  },
  {
    code: "DOP",
    name: "Dominican Peso",
    symbol: "RD$",
  },
  {
    code: "EGP",
    name: "Egyptian Pound",
    symbol: "ج.م.",
  },
  {
    code: "GEL",
    name: "Georgian Lari",
    symbol: "₾",
  },
  {
    code: "INR",
    name: "Indian Rupee",
    symbol: "₹",
  },
  {
    code: "IQD",
    name: "Iraqi Dinar",
    symbol: "د.ع.",
  },
  {
    code: "IRR",
    name: "Iranian Rial",
    symbol: "﷼",
  },
  {
    code: "JPY",
    name: "Japanese Yen",
    symbol: "¥",
  },
  {
    code: "KPW",
    name: "North Korean Won",
    symbol: "₩",
  },
  {
    code: "KWD",
    name: "Kuwaiti Dinar",
    symbol: "د.ك.",
  },
  {
    code: "KYD",
    name: "Cayman Islands Dollar",
    symbol: "CI$",
  },
  {
    code: "KZT",
    name: "Kazakhstani Tenge",
    symbol: "₸",
  },
  {
    code: "MAD",
    name: "Moroccan Dirham",
    symbol: "د.م.",
  },
  {
    code: "MXN",
    name: "Mexican Peso",
    symbol: "MX$",
  },
  {
    code: "NOK",
    name: "Norwegian Krone",
    symbol: "kr",
  },
  {
    code: "NZD",
    name: "New Zealand Dollar",
    symbol: "NZ$",
  },
  {
    code: "OMR",
    name: "Omani Rial",
    symbol: "ر.ع.",
  },
  {
    code: "PHP",
    name: "Philippine Peso",
    symbol: "₱",
  },
  {
    code: "PLN",
    name: "Polish Zloty",
    symbol: "zł",
  },
  {
    code: "QAR",
    name: "Qatari Riyal",
    symbol: "ر.ق.",
  },
  {
    code: "SAR",
    name: "Saudi Riyal",
    symbol: "ر.س.",
  },
  {
    code: "SCR",
    name: "Seychellois Rupee",
    symbol: "Rs",
  },
  {
    code: "SEK",
    name: "Swedish Krona",
    symbol: "kr",
  },
  {
    code: "SGD",
    name: "Singapore Dollar",
    symbol: "S$",
  },
  {
    code: "SYP",
    name: "Syrian Pound",
    symbol: "ل.س.",
  },
  {
    code: "UAH",
    name: "Ukrainian Hryvnia",
    symbol: "₴",
  },
];
